export const tr = {
    'company-period-time': 'kampanya süresi',
    'days-setting': 'Gün sayısı: {limit}',
    'days-setting-changed': 'Gün sayısı: {oldLimit} {newLimit}',
    'shows-setting': 'Gösterim sınırlaması: {limit}',
    'shows-setting-changed': 'Gösterim sınırlaması: {oldLimit} {newLimit}'
};
